export default {"src":"/_next/static/media/Airbnb_Logo.5aebe33b.svg","height":100,"width":320,"blurWidth":0,"blurHeight":0};